<template>
  <div class="loader"
  >
    <div class="lds-ring" >
      <div :style="{ border: `8px solid ${color}`, borderColor: `${color} transparent transparent transparent` }" ></div>
      <div :style="{ border: `8px solid ${color}`, borderColor: `${color} transparent transparent transparent` }" ></div>
      <div :style="{ border: `8px solid ${color}`, borderColor: `${color} transparent transparent transparent` }" ></div>
      <div :style="{ border: `8px solid ${color}`, borderColor: `${color} transparent transparent transparent` }" ></div>

    </div>
  </div>
</template>

<script>
export default {
  name: 'loader',
  props: {
    movie: Object,
    color: {
      type: String,
      default: '#fff'
    }
  },

  data: function(){
    return {
    }
  },

  methods: { },

  mounted: function(){ }

}
</script>

<style scoped lang="scss">
.lds-ring {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
}
.lds-ring div {
  box-sizing: border-box;
  display: block;
  position: absolute;
  width: 64px;
  height: 64px;
  margin: 8px;
  opacity: 1;
  border: 8px solid #fff;
  border-radius: 50%;
  animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  border-color: #fff transparent transparent transparent;
}
.lds-ring div:nth-child(1) {
  animation-delay: -0.45s;
}
.lds-ring div:nth-child(2) {
  animation-delay: -0.3s;
}
.lds-ring div:nth-child(3) {
  animation-delay: -0.15s;
}
@keyframes lds-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.loader{
}
</style>
